import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetDriverRatings } from '../../store/Reducers/DriverRatingsSlice';
import { DriverRatingsDatagrid } from '../../components/DataGrid/DriverRatings/DriverRatingsDatagrid';

export const DriverRatingsPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetDriverRatings());
    };
  }, [dispatch]);

  return <DriverRatingsDatagrid />;
};
